'use strict';

angular.module('pmtPlacesApp.controllers').controller('BrandPageConflictsFacebookCtrl', [
	'$scope',
	'$stateParams',
	'$http',
	'$timeout',
	function ($scope, $stateParams, $http, $timeout) {
		$scope.site = $stateParams.site;
		let timerPromise;
		$scope.count = 0;
		$scope.index = 1;
		$scope.conflicts = [];
		$scope.loading = true;
		let getSitesWithConflicts = function () {
			$timeout.cancel(timerPromise);
			$http
				.get('api/' + $scope.site + '/facebook/conflict/brandpage')
				.then(function (res) {
					$scope.count = res.data.data.length;
					$scope.conflicts = res.data.data;
					$scope.loading = false;
					let timeoutCb = function () {
						getSitesWithConflicts();
					};

					let i;
					for (i = 0; i < res.data.data.length; i++) {
						if (
							res.data.data[i].validation.dataDiff.profileImage.pendingDiff ||
							res.data.data[i].validation.dataDiff.coverImage.pendingDiff
						) {
							timerPromise = $timeout(timeoutCb, 3000);
							break;
						}
					}
				})
				.catch(function () {
					$scope.loading = false;
				});
		};

		$scope.onPublish = function () {
			getSitesWithConflicts();
		};

		$scope.previous = function () {
			if ($scope.index > 1) {
				$scope.index--;
			} else {
				$scope.index = 1;
			}
		};

		$scope.next = function () {
			if ($scope.index < $scope.count) {
				$scope.index++;
			} else {
				$scope.index = 1;
			}
		};

		$scope.keydown = function (e) {
			if (e.keyCode === 37) {
				$scope.previous();
			}
			if (e.keyCode === 39) {
				$scope.next();
			}
		};

		$scope.$on('$destroy', function () {
			$timeout.cancel(timerPromise);
		});

		getSitesWithConflicts();
	}
]);
